import { RenderTargetWrapper } from "../renderTargetWrapper.js";
/** @internal */
export class WebGPURenderTargetWrapper extends RenderTargetWrapper {
}
